import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getContact } from "store/actions";

const Show = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const { contact } = useSelector((state) => state.contacts);

  useEffect(() => {
    dispatch(getContact({ id }));
  }, [dispatch, id]);

  return (
    <div className="contact-wrap">
      <div className="card">
        <div className="card-head">
          <h4 className="card-title">تفاصيل الطلب</h4>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered">
              <tbody>
                <tr>
                  <td>
                    <strong>الاسم</strong>
                  </td>
                  <td>{contact?.name}</td>
                </tr>
                <tr>
                  <td>
                    <strong>البريد الالكتروني</strong>
                  </td>
                  <td>{contact?.email}</td>
                </tr>
                <tr>
                  <td>
                    <strong>رقم الهاتف</strong>
                  </td>
                  <td>{contact?.phone}</td>
                </tr>

                <tr>
                  <td>
                    <strong>الرسالة</strong>
                  </td>
                  <td>{contact?.message}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Show;
